module.exports = __webpack_public_path__ + "img/subway_kiev.4c89400.png";